export default __webpack_public_path__ + "i18n/pt-BR.11502a37d9b22d67d82d168d8c4e14b6.json";